const development = {
  ASSET_ORIGIN: "https://cdn.navalabs.io",
  ASSET_MAP_PATH: "/garden/img_7HamQp",
  ASSET_MAP_PATH_ROOKIE: "/garden/img_7HamWr",
  SPLASH_PRO: "/assets/splash-pro-arena_4zCqWh.png",
  SPLASH_ROOKIE: "/assets/splash-rookie-island_4zCqWh.png",
  IS_TESTNET: true,
  IS_REFCODE_REQUIRED: false,
  PRIVY_APP_ID: "cm82t94ab02x7n3205bejpvy5",
  PRIVY_CLIENT_ID: "client-WY5hqGCcsAiKb4vatxWrQb6ErzG1LzqmjM4JkLJdEv6rE",
  // NOTE: TEE CONFIG
  // PRIVY_APP_ID: "cmmbn5p4q008c0cjri3tc6qqt",
  // PRIVY_CLIENT_ID: "client-WY6WsY7dpeCTvAPFyhtJ1D56ThnSniPhmSEsmZKpGfwDd",

  // dev
  RPC_URL: "https://api.devnet.solana.com",
  API_BASE_URL: "https://v12-cfl-backend-staging.up.railway.app",
  SHARE_PAGE_BASE_URL: "https://v12-cfl-backend-staging.up.railway.app/share",
  PRICE_INGESTOR_URL: "https://price-ingestor-staging.up.railway.app",

  // prod
  // RPC_URL: "https://helius-rpc-proxy.tools-navalabs.workers.dev",
  // API_BASE_URL: "https://v12-cfl-backend-production.up.railway.app",

  // local
  // API_BASE_URL: "http://localhost:8080",
  // RPC_URL: "https://api.devnet.solana.com",
  // PRICE_INGESTOR_URL: "http://localhost:8081",

  FEE_RECIPIENT: "53uWfxz8FczDKpzWphdNMX5XycZJJ38vffL6EWUusDjW",
  POSTHOG: {
    HOST: "/cortex",
    KEY: "phc_uBVoYWa3sfgXNNt3LttrqBPdEQbIMqp1qmtEor1JHzE",
  },
  WORLD_MINI_APP: {
    ID: "app_aa63ae098982422e9de26d0c617e7df0" as `app_${string}`,
    VERIFY_ACTION: "verify-human",
  },
  ONESIGNAL_APP_ID: "77151622-3ded-44b6-8ddd-596200fa5314",
  SUPABASE_URL: "https://cofvgxfezvwkjukmvfwl.supabase.co",
  SUPABASE_KEY:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNvZnZneGZlenZ3a2p1a212ZndsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDUyMzcwNTAsImV4cCI6MjA2MDgxMzA1MH0.rACC3hFGANn4WmThSiinPXVF9ZzbfAw9Slf1EQ4U1lo",
  TRITON_PYTHNET_API: "https://cfl-pythnet-2711.mainnet.pythnet.rpcpool.com",
  CONVEX_URL: "https://valiant-magpie-981.convex.cloud",
  CURRENT_SEASON: 1,
  USDC_MINT: "7NXuALfKqEmcAt46QSTnN8RrFMoUiUGo2KkLLfZSdviK",

  GEO_BLOCK: {
    enabled: true,
    blockedCountries: ["US"],
  },

  //WARN: Enabling this will set the entire app inaccessible. Do not forget to toggle it back off
  MAINTENANCE: {
    enabled: false,
    message: undefined as string | undefined,
  },
};

export default development;
